import { GamstopNotificationType, GamstopPositiveNotificationType } from 'src_server/types/notificationData';

export const GAMSTOP_CHANNEL = 'gamstop-changes';
export const GAMSTOP_TYPE_POS = 'gamstop-positive';
export const GAMSTOP_TYPE_NEG = 'gamstop-negative';
export const GAMSTOP_NOTIFICATION_ENTITY = GAMSTOP_TYPE_POS;

export const isGamstopNotification = (notification: { type: string }): notification is GamstopNotificationType => {
    return notification.type === GAMSTOP_TYPE_POS || notification.type === GAMSTOP_TYPE_NEG;
};

export const isVisibleGamstopPositiveNotification = (notification: GamstopPositiveNotificationType): boolean => {
    const { underExclusion, previouslyPositive } = notification.details;
    return underExclusion || previouslyPositive;
};

export const isVisibleGamstopNotification = (notification: GamstopNotificationType): boolean => {
    if (notification.type === GAMSTOP_TYPE_NEG) {
        return true;
    }

    return isVisibleGamstopPositiveNotification(notification);
};

export const getGamstopStatusLabel = (notification: GamstopNotificationType): string => {
    if (notification.type === GAMSTOP_TYPE_NEG) {
        if (notification.details.previouslyPositive) {
            return 'PP - Previously Positive';
        }
        return 'N - Account no longer blocked';
    }

    const { underExclusion, previouslyPositive } = notification.details;

    if (underExclusion) {
        return 'Y - Active Gamstop';
    }

    if (previouslyPositive) {
        return 'PP - Previously Positive Gamstop';
    }

    return '';
};

export const getGamstopStatusVariant = (
    notification: GamstopNotificationType
): 'active' | 'previously-positive' | 'negative' => {
    if (notification.type === GAMSTOP_TYPE_NEG) {
        return 'negative';
    }

    return notification.details.underExclusion ? 'active' : 'previously-positive';
};

export const filterVisibleGamstopPositiveNotifications = (
    notifications: Array<GamstopPositiveNotificationType>
): Array<GamstopPositiveNotificationType> => {
    return notifications.filter(isVisibleGamstopPositiveNotification);
};

export const filterVisibleGamstopNotifications = (
    notifications: Array<GamstopNotificationType>
): Array<GamstopNotificationType> => {
    return notifications.filter(isVisibleGamstopNotification);
};

export const getGamstopNotificationEntity = (
    notification: GamstopNotificationType
): typeof GAMSTOP_TYPE_POS | typeof GAMSTOP_TYPE_NEG => {
    return notification.type;
};
